import React from "react";

interface InnerbannerProps {
  bnrHeading: string;
}

const Innerbanner: React.FC<InnerbannerProps> = ({ bnrHeading }) => {
  return (
    <div className="innerBnrbg">
      <h1 className="text-center font-inter font-medium md:font-extrabold text-white text-2xl lg:text-3xl xl:text-5xl pt-20">{bnrHeading}</h1>
    </div>
  );
};

export default Innerbanner;
